<div class="container text-center p-4">
  <h2 class="mb-3 text-primary">TelOne Client Service Charter</h2>
  <p class="mb-4 text-muted">View or download our Client Service Charter.</p>

  <button class="btn btn-outline-secondary mb-4" routerLink="/">
    ← Back to Homepage
  </button>

  <!-- Image Viewer -->
  <div class="image-viewer">
    <picture>
      <source media="(max-width: 768px)" [srcset]="imageSrcMobile" />
      <img [src]="imageSrc" alt="Client Service Charter" class="img-fluid responsive-image" />
    </picture>
  </div>

  <a [href]="pdfApiUrl" download class="btn btn-primary mt-3" target="_blank">
    Download Charter (PDF)
  </a>
</div>
